import { render, staticRenderFns } from "./SearchMatchRulesEdit.vue?vue&type=template&id=57408dc0&scoped=true"
import script from "./SearchMatchRulesEdit.vue?vue&type=script&lang=js"
export * from "./SearchMatchRulesEdit.vue?vue&type=script&lang=js"
import style0 from "./SearchMatchRulesEdit.vue?vue&type=style&index=0&id=57408dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57408dc0",
  null
  
)

export default component.exports